module.exports = __webpack_public_path__ + "img/guide-img.3e326882.png";